const INITIAL_STATE = {
    venda: {},
    vendas: [],
    vendasEmAndamento: [],
    vendasCanceladas: [],
    vendasConcluidas: [],
    loading: false
}

export default function Vendas(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'VENDA_LOADING' :
            return { ...state, loading: action.payload };
        case 'VENDA_FETCHED':
            return { ...state, venda: action.payload };
        case 'VENDAS_FETCHED':
            return { ...state, vendas: action.payload };
        case 'VENDAS_EM_ANDAMENTO_FETCHED':
            return { ...state, vendasEmAndamento: action.payload };
        case 'VENDAS_CANCELADAS_FETCHED':
            return { ...state, vendasCanceladas: action.payload };
        case 'VENDAS_CONCLUIDAS_FETCHED':
            return { ...state, vendasConcluidas: action.payload };
        default:
            return state
    }
}